import styled from 'styled-components';

import { media } from '@simplywallst/ui-core';

import RootDataTable, { Props } from '../DataTable';

export const DataTable = styled(RootDataTable)<Props>`
  padding-top: 8px;
`;

export const NoData = styled('span')<Props>`
  ${({ theme }) => theme.typography.tiny}
  color: ${({ theme }) => theme.color.whiteRGBA(0.5)} !important;
  text-align: center;
  background: transparent;
  cursor: auto !important;
  min-height: ${({ theme }) => theme.x5spacePx}px;
`;

export const TableRow = styled('tr')`
  &:nth-child(1) {
    td {
      border-top: 0 !important;
    }
  }
`;

export const Detail = styled('td')`
  > a {
    max-width: 230px;
    ${media.mdDown`
      max-width: 290px;
    `};
  }
  color: ${({ theme }) => theme.color.whiteRGBA(0.5)};
`;

export const Date = styled('span')`
  color: ${({ theme }) => theme.color.white};
  margin-right: ${({ theme }) => theme.x2spacePx}px;
`;

export const TickerSymbol = styled('span')`
  color: ${({ theme }) => theme.color.brand01};
  margin-right: ${({ theme }) => theme.x1spacePx / 2}px;
`;

export const Name = styled('span')`
  ${({ theme }) => theme.typography.tiny}
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const SeeMore = styled('tr')`
  &:hover,
  &:active {
    td {
      background: transparent !important;
    }
  }
  button {
    ${({ theme }) => theme.typography.tiny}
    text-align: center;
    color: ${({ theme }) => theme.color.whiteRGBA(0.5)};
    display: block;
    width: 100%;
    padding: ${({ theme }) => theme.x2spacePx - 4}px;
  }
`;
